import type { IAppState } from '../../common/state';

export const selectResultPuids = (state: IAppState) => state.results.puids;
